export default __webpack_public_path__ + "static/media/match.b5b5d14f.png";